import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { PendingData } from "@modules/+new/shared/universal-modal/components/_presets/pending-preset/entities/pending-data";
import { Router } from "@angular/router";
import { LastActivatedRoute } from "@modules/+new/shared/universal-modal/functions/last-activated-route.service";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";
import { TransactionsFacade } from "@modules/+new/transactions/domain/+state/transactions.facade";
import { take } from "rxjs/operators";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	selector: "app-email-mismatch-preset",
	templateUrl: "./email-mismatch-preset.component.html",
	styleUrls: ["./email-mismatch-preset.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class EmailMismatchPresetComponent implements OnInit {
	private data: PendingData = {};
	public tryAgainButtonDisabled: boolean = false;

	constructor(
		private readonly route: LastActivatedRoute,
		private readonly router: Router,
		private readonly transactionFacade: TransactionsFacade,
		private readonly segmentEvents: SegmentService,
		private readonly rudderstackService: RudderstackService
	) {}

	ngOnInit(): void {
		const { pid, fpid } = this.route.getAllParams();
		this.data.transactionId = fpid;
		this.data.fiatWalletId = pid;
		this.segmentEvents.track({
			name: "PayPal Email Mismatch Screen Viewed",
			properties: {
				flow_it_happened_on: "Deposit"
			}
		});
		this.rudderstackService.track({
			name: "PayPal Email Mismatch Screen Viewed",
			properties: {
				flow_it_happened_on: "Deposit"
			}
		});
	}

	public goToPaymentMethodSelection(): void {
		this.router.navigate([{ outlets: { [ROUTER_OUTLET_NAME]: ["fiat-deposit", "select-payment-option"] } }], {
			queryParams: {
				walletGuid: this.data.fiatWalletId
			}
		});
	}

	public tryAgain(): void {
		this.tryAgainButtonDisabled = true;
		this.transactionFacade
			.getFiatTransaction$(this.data.fiatWalletId, this.data.transactionId)
			.pipe(take(1))
			.subscribe((tx) =>
				this.router.navigate([{ outlets: { [ROUTER_OUTLET_NAME]: ["fiat-deposit", "enter-amount"] } }], {
					queryParams: {
						walletGuid: this.data.fiatWalletId,
						paymentOptionId: tx.paymentOptionId
					}
				})
			);
	}
}
